import { suppliersTableColumnDefinitions } from '../constants/suppliersTableColumnDefinitions'
import { SuppliersTableSortKey } from '../types/suppliersTableSortKey'

const suppliersTableSortableKeys = new Set<string>(
  suppliersTableColumnDefinitions
    .filter((column) => 'sortable' in column && column.sortable)
    .map((column) => column.key),
)

export const isSuppliersTableSortKey = (key: string): key is SuppliersTableSortKey =>
  suppliersTableSortableKeys.has(key)
